module.exports = __webpack_public_path__ + "img/csomagjaink__also_bg_372.d0f526d7.jpg";